// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseEnvironment } from './ResponseEnvironment';
import {
  ResponseEnvironmentFromJSON,
  ResponseEnvironmentFromJSONTyped,
  ResponseEnvironmentToJSON,
  ResponseEnvironmentToJSONTyped,
} from './ResponseEnvironment';

/**
 *
 * @export
 * @interface ResponseEnvironmentList
 */
export interface ResponseEnvironmentList {
  /**
   *
   * @type {Array<ResponseEnvironment>}
   * @memberof ResponseEnvironmentList
   */
  items?: Array<ResponseEnvironment>;
}

/**
 * Check if a given object implements the ResponseEnvironmentList interface.
 */
export function instanceOfResponseEnvironmentList(
  value: object,
): value is ResponseEnvironmentList {
  return true;
}

export function ResponseEnvironmentListFromJSON(
  json: any,
): ResponseEnvironmentList {
  return ResponseEnvironmentListFromJSONTyped(json, false);
}

export function ResponseEnvironmentListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironmentList {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(ResponseEnvironmentFromJSON),
  };
}

export function ResponseEnvironmentListToJSON(
  json: any,
): ResponseEnvironmentList {
  return ResponseEnvironmentListToJSONTyped(json, false);
}

export function ResponseEnvironmentListToJSONTyped(
  value?: ResponseEnvironmentList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(ResponseEnvironmentToJSON),
  };
}
